import { render, staticRenderFns } from "./TheSnapshotMain.vue?vue&type=template&id=1a40e87a&"
import script from "./TheSnapshotMain.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports